import { type Consumer, createConsumer } from '@rails/actioncable'
import { useEffect, useState } from 'react'

// Realtime in-app notification unread count (architecture §6.6). Seeds from the
// Inertia-shared count, then subscribes to NotificationChannel so the bell stays
// live without a page load.
let consumer: Consumer | null = null

function cable(): Consumer {
  if (!consumer) consumer = createConsumer()
  return consumer
}

export function useUnreadNotifications(initial: number): number {
  const [unread, setUnread] = useState(initial)

  useEffect(() => setUnread(initial), [initial])

  useEffect(() => {
    const subscription = cable().subscriptions.create('NotificationChannel', {
      received(data: { unread_count?: number }) {
        if (typeof data.unread_count === 'number') setUnread(data.unread_count)
      },
    })
    return () => subscription.unsubscribe()
  }, [])

  return unread
}
